import { Input } from "@/components/ui/input";

const fmt = (v) => (v === "" || v == null || isNaN(Number(v)) ? "" : Number(v).toLocaleString("id-ID"));
const parse = (s) => { const d = String(s).replace(/[^\d]/g, ""); return d === "" ? "" : Number(d); };

export function MoneyInput({ value, onChange, className, testId, placeholder = "0", ...rest }) {
  return (
    <div className="relative">
      <span className="pointer-events-none absolute left-3 top-1/2 -translate-y-1/2 text-xs text-muted-foreground">Rp</span>
      <Input inputMode="numeric" value={fmt(value)} placeholder={placeholder} data-testid={testId} className={`pl-9 font-mono ${className || ""}`}
        onChange={(e) => onChange(parse(e.target.value))} {...rest} />
    </div>
  );
}
